export enum Page {
  INITIAL = 'initial',
  DOCUMENT_VIEWER = 'document-viewer',
  EMPTY = 'empty',
  START = 'start',
  FAQ = 'faq',
  VERIFY = 'verify',
  ADVERSE = 'adverse',
  INVALID_ADDRESS = 'invalid-address',
  FULL_SSN = 'full-ssn',
  ERROR = 'error',
  ACCEPT = 'accept',
  LOAN_CONSENT = 'loan-consent',
  PAY = 'pay',
  REAPPLY = 'reapply',
  REACCEPT = 're-accept',
  RECONFIRM = 'reconfirm',
  OTHER_PAYMENT = 'other-payment',
  AGENT_ENDED = 'agent-ended',
  TRIP_EXPIRED = 'trip-expired',
  OFFER_EXPIRED = 'offer-expired',
  HANDOFF = 'handoff',
  NOI = 'notice-of-incompleteness',
  OUT_OF_FILTER = 'out_of_filter',
  CREDIT_FREEZE = 'credit-freeze',
}

export enum Endpoint {
  START = '/start',
  APPLY = '/apply',
  APPLY_QUEBEC = '/apply-quebec',
  VERIFY = '/verify',
  UPDATE_APPLICATION = '/update/application',
  CARD = '/card',
  FULL_SSN = '/full-ssn',
  SSN = '/ssn',
  LOAN_CONSENT = '/loan-consent',
  ACCEPT = '/accept',
  ACCEPT_MULTIPLE_OFFER = '/accept-multiple-offer',
}

export enum OrderLoadStatus {
  NOT_STARTED = 0,
  LOADING = 1,
  LOADED = 2,
  FAILED = 3,
}

export enum Promo {
  DEFERRED_PAYMENT = 'deferred-payment',
  LIMITED_TIME = 'limited-time',
  PRE_SELECT = 'pre-select',
  ONE_MONTH_DELAYED = '1-month-delayed',
  THREE_MONTH_DELAYED = '3-month-delayed',
  SIX_MONTH_DELAYED = '6-month-delayed',
  SEVEN_MONTH_DELAYED = '7-month-delayed',
}
